import { loadKpiData } from '../reducers/kpiDataReducer';

const toCSV = (v) => {
	if (!v) return null;
	const arr = Array.isArray(v) ? v : [v];
	return arr.length > 0 ? arr.join(',') : null;
};

const buildChartsForTech = (state, tech) => {
	const { filters, lockdown } = state;
	const lockdownId = lockdown.selected?.lockdownId;
	if (!lockdownId || !tech) return [];

	const techFilters = filters.byTech[tech] ?? {};
	const slots       = (filters.kpiSel[tech] ?? []).slice(0, filters.numCharts ?? 3);

	const base = {
		lockdownId,
		aggLevel:  filters.aggLevel,
		dateFrom:  filters.dateFrom,
		dateTo:    filters.dateTo,
		jvId:      toCSV(techFilters.jvId),
		cellName:  toCSV(techFilters.cellName),
		side:      toCSV(techFilters.side),
		polygon:   toCSV(techFilters.polygon),
		vendor:    toCSV(techFilters.vendor),
		manager:   toCSV(techFilters.manager),
		optimiser: toCSV(techFilters.optimiser),
	};

	return slots.map(kpiName => ({ ...base, tech, kpiName }));
};

export const applyAndFetchKpiData = () => (dispatch, getState) => {
	const state = getState();
	const techs = [state.filters.tech1, state.filters.tech2].filter(Boolean);
	const charts = techs.flatMap(t => buildChartsForTech(state, t));
	if (charts.length) dispatch(loadKpiData(charts));
};

export const applyAndFetchTech = (tech) => (dispatch, getState) => {
	const charts = buildChartsForTech(getState(), tech);
	if (charts.length) dispatch(loadKpiData(charts));
};

export const fetchTech2Data = (tech2) => (dispatch, getState) => {
	if (!tech2) return;
	const charts = buildChartsForTech(getState(), tech2);
	if (charts.length) dispatch(loadKpiData(charts));
};
